<template>
  <div class="page-wrapper">
    <component v-bind:is="headerComponent"></component>
    <div class="content">
      <div class="container">
        <div class="content__aside">
          <component v-bind:is="sidebarComponent"></component>
        </div>
        <div class="content__main">
          <component name="article" v-bind:is="articleComponent"></component>
        </div>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent } from '@/utils/common'

export default {
  name: 'account_support',
  computed: {
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header')
    },
    sidebarComponent() {
      return getComponent(this.$store.getters.flowObject, 'sidebar')
    },
    articleComponent() {
      return getComponent(this.$store.getters.flowObject, 'article')
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';
</style>
